import { useGlobalState } from '@/hooks';
import { LoggedInESBanner } from './components/LoggedInBanner';
import { AnonymousESBanner } from './components/AnonymousESBanner';

export const ESBanner = () => {
  const { isLoggedIn } = useGlobalState();

  if (isLoggedIn) {
    return <LoggedInESBanner />;
  }

  return <AnonymousESBanner />;
};
